import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { GuiService } from './gui.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifications = [];
  notificationUpdateStarted: boolean = false;
  notificationSpinner: boolean = false;

  constructor(private restService: RestService, public guiService: GuiService) { }

  startNotificationUpdate(){
    this.getNotifications();
    this.notificationUpdateStarted = true;
    setInterval(() => {
      this.getNotifications();
    }, 900000);
  }

  getNotifications(){
    this.notificationSpinner = true;
    this.restService.postService('node','/user-notifications',{userId: this.guiService.userLogged.user.id}).subscribe((ris)=>{
      this.notifications = [];
      ris.forEach(element => {
        this.notifications.push(element)
      });
      this.notificationSpinner = false;
      console.debug('notifications', this.notifications)
    })
  }
}
